import { render } from "./CheckoutApproval.vue?vue&type=template&id=4e83b87c"
import script from "./CheckoutApproval.vue?vue&type=script&lang=js"
export * from "./CheckoutApproval.vue?vue&type=script&lang=js"

import exportComponent from "/Users/patricksantner/projects/alpbach-ticketshop-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__